export default __webpack_public_path__ + "static/media/base-report10.66ed4974.png";